/**
 * @fileoverview Marketing-site CAPTCHA policy flag.
 * @module portals/marketing-website/config/turnstileConfig
 *
 * The shared `@puffin-core/captcha-ui` package owns the canonical
 * TURNSTILE_SITE_KEY / IS_DEVELOPMENT / IS_CAPTCHA_CONFIGURED / SHOW_DEV_WARNING
 * constants — consumers should import those directly from the shared package.
 *
 * This file only re-exports the ONE app-policy flag that `@puffin-core/captcha-ui`
 * deliberately does NOT encode: whether CAPTCHA is *required* for marketing-site
 * form submission (also consumed cross-portal by the storefront contact block —
 * `portals/storefront/services/storefrontContactForm.js`). Required in prod
 * always; required in dev only if a site key is configured (so local devs
 * without a key can still submit forms).
 *
 * CAPTCHA-POLICY-001 (2026-07-11): replaced the app-local inline ternary
 * (byte-identical copy across six sibling apps) with the canonical helper
 * consumed from the package barrel, mirroring the pos-web reference. Also
 * unifies the dev-mode source onto the package's `import.meta.env.DEV`
 * (previously `MODE !== 'production'` here — differs only under custom build
 * modes, where the canonical form is required=true, i.e. fail-closed).
 */

import {
  IS_DEVELOPMENT,
  IS_CAPTCHA_CONFIGURED,
  deriveCaptchaRequired,
} from '@puffin-core/captcha-ui';

/**
 * Whether CAPTCHA is required for form submission.
 *
 * Derived through the shared pure helper (promoted to
 * `@puffin-core/captcha-ui` by CLEAN-SWEEP-001 follow-up Item 3) so the
 * production arm of the policy stays testable under Jest, where the
 * module-load value of `IS_DEVELOPMENT` is pinned by the
 * `import.meta.env → process.env` babel rewrite.
 * @constant {boolean}
 */
export const IS_CAPTCHA_REQUIRED = deriveCaptchaRequired(IS_DEVELOPMENT, IS_CAPTCHA_CONFIGURED);
